import { Component } from '@angular/core';
import { HeroSectionComponent } from '../../shared/components/hero-section/hero-section.component';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { MatExpansionModule } from '@angular/material/expansion';
import { DarkModeService } from '../../shared/services/darkmode.service';

@Component({
    selector: 'app-terms-and-conditions',
    imports: [
        HeroSectionComponent,
        TranslateModule,
        CommonModule,
        MatExpansionModule,
    ],
    templateUrl: './terms-and-conditions.component.html',
    styleUrl: './terms-and-conditions.component.scss'
})
export class TermsAndConditionsComponent {
  panelOpenState = false;
  darkMode = false;

  principalAccordion: {
    index: number;
    expanded: boolean;
  }[] = [
    {
      index: 0,
      expanded: false,
    },
    {
      index: 1,
      expanded: false,
    },
    {
      index: 2,
      expanded: false,
    },
    {
      index: 3,
      expanded: false,
    },
    {
      index: 4,
      expanded: false,
    },
    {
      index: 5,
      expanded: false,
    },
    {
      index: 6,
      expanded: false,
    },
    {
      index: 7,
      expanded: false,
    },
    {
      index: 8,
      expanded: false,
    },
    {
      index: 9,
      expanded: false,
    },
    {
      index: 10,
      expanded: false,
    },
  ];

  constructor(private darkmodeService: DarkModeService) {
    this.darkmodeService.isDarkMode.subscribe((isDark) => {
      this.darkMode = isDark;
    });
  }

  onExpandChange(index: number) {
    this.principalAccordion[index].expanded =
      !this.principalAccordion[index].expanded;
  }
}
